// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__wOrt9","col":"styles_col__2_M68"};